<template>
  <div class="page-style">
    <div class="loginBox">
      <div class="inner">
        <div class="signIn">
          <div class="top">
            <div class="title">{{ formTitle }}</div>
            <div class="subtitle">
              All fields are required
            </div>
          </div>

          <form v-on:submit.prevent="onDetailsSubmit" v-if="accountMenuScope === 'details'">
            <div class="form">
              <input
                  type="text"
                  placeholder="First name"
                  autofocus
                  v-model="firstName"
                  class="w100"
              />
              <input
                  type="text"
                  placeholder="Last name"
                  v-model="lastName"
                  class="w100"
              />
              <input
                  type="password"
                  class="w100"
                  placeholder="Current Password"
                  v-model="currentPassword.value"
                  @blur="validateCurrentPassword"
                  @keydown="validateCurrentPassword"
              />
            </div>
            <div v-if="detailsFailMsg.length>0" class="has-text-danger login-error">
              <font-awesome-icon :icon="['fas', 'triangle-exclamation']"/>
              {{ detailsFailMsg }}
            </div>
            <div v-if="detailsSuccessMsg.length>0" class="has-text-success">
              <font-awesome-icon :icon="['fas', 'thumbs-up']"/>
              {{ detailsSuccessMsg }}
            </div>
            <input
                type="submit"
                value="Submit"
                class="action"
                :class="{ 'action-disabled': !detailsValid }"
            />
          </form>

          <form v-on:submit.prevent="onPasswordChangeSubmit" v-if="accountMenuScope === 'password'">
            <div class="form">
              <input
                  type="password"
                  class="w100"
                  placeholder="Current Password"
                  v-model="currentPassword.value"
                  @blur="validateCurrentPassword"
                  @keydown="validateCurrentPassword"
              />

              <input
                  type="password"
                  class="w100"
                  placeholder="New Password"
                  v-model="newPassword.value"
                  @blur="validateNewPassword"
                  @keydown="validateNewPassword"
              />

              <input
                  type="password"
                  class="w100"
                  placeholder="Confirm New Password"
                  v-model="confirmNewPassword.value"
                  @blur="validateConfirmNewPassword"
                  @keydown="validateConfirmNewPassword"
              />
            </div>
            <div v-if="passChangeFailMsg.length>0" class="has-text-danger login-error">
              <font-awesome-icon :icon="['fas', 'triangle-exclamation']"/>
              {{ passChangeFailMsg }}
            </div>
            <div v-if="passChangeSuccessMsg.length>0" class="has-text-success">
              <font-awesome-icon :icon="['fas', 'thumbs-up']"/>
              {{ passChangeSuccessMsg }}
            </div>
            <input
                type="submit"
                value="Submit"
                class="action"
                :class="{ 'action-disabled': !passChangeValid }"
            />
          </form>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['$axios'],
  props: {
    accountMenuScope: String
  },
  data() {
    return {
      currentData: {},
      detailsSuccessMsg: '',
      detailsFailMsg: '',

      passChangeFailMsg: '',
      passChangeSuccessMsg: '',

      passwordRegex: /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/,

      firstName: "",
      lastName: "",
      currentPassword: {
        value: "",
        error: false
      },
      newPassword: {
        value: "",
        error: false
      },
      confirmNewPassword: {
        value: "",
        error: false
      },
    };
  },
  methods: {
    validateCurrentPassword() {
      this.currentPassword.error = this.currentPassword.value === "";
    },
    validateNewPassword() {
      this.newPassword.error = this.newPassword.value === "";
    },
    validateConfirmNewPassword() {
      this.confirmNewPassword.error = this.confirmNewPassword.value === "";
    },
    onDetailsSubmit() {
      let vm = this;
      try {
        vm.$axios
            .post('/auth/user/detailChange', {
              fname: vm.firstName,
              lname: vm.lastName,
              password: vm.currentPassword.value,
            }, {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.currentData.token}`
              }
            })
            .then(function (response) {
              if (response.data.success) {
                localStorage.setItem("account", JSON.stringify(response.data.msg));
                vm.detailsFailMsg = '';
                vm.detailsSuccessMsg = 'Your new details have been saved';
                setTimeout(function () {
                  location.reload();
                }, 3000);
              } else {
                vm.detailsSuccessMsg = '';
                vm.detailsFailMsg = response.data.msg;
              }
            })
      } catch (error) {
        console.error(error);
      }
    },
    onPasswordChangeSubmit() {
      let vm = this;
      try {
        vm.$axios
            .post('/auth/user/passChange', {
              password: vm.currentPassword.value,
              newpass: vm.newPassword.value
            }, {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.currentData.token}`
              }
            })
            .then(function (response) {
              if (response.data.success) {
                localStorage.setItem("account", JSON.stringify(response.data.msg));
                vm.passChangeFailMsg = '';
                vm.passChangeSuccessMsg = 'Your new password has updated';
                setTimeout(function () {
                  location.reload();
                }, 3000);
              } else {
                vm.passChangeSuccessMsg = '';
                vm.passChangeFailMsg = response.data.msg;
              }
            })
      } catch (error) {
        console.error(error);
      }
    }
  },
  computed: {
    formTitle: function () {
      let vm = this,
          formTitleText = 'Form';
      switch (vm.accountMenuScope) {
        case 'details':
          formTitleText = 'Change of account details';
          break;
        case 'password':
          formTitleText = 'Change of account password';
          break;
      }
      return formTitleText;
    },
    validFirstName() {
      return this.firstName.length > 0;
    },
    validLastName() {
      return this.lastName.length > 0;
    },
    currentPasswordValid() {
      return this.currentPassword.value.length > 0;
    },
    passChengePasswordValid() {
      return (this.newPassword.value === this.confirmNewPassword.value) && (this.newPassword.value.length > 0);
    },
    detailsValid() {
      return (
          this.currentPasswordValid &&
          this.validFirstName &&
          this.validLastName
      );
    },
    passChangeValid() {
      return (
          this.passChengePasswordValid
      );
    },
  },
  async mounted() {
    let vm = this;
    const storedAccount = localStorage.getItem("account");
    vm.currentData = JSON.parse(storedAccount);
    vm.firstName = vm.currentData.fname;
    vm.lastName = vm.currentData.lname;
  }
}
</script>

<style scoped>
@mixin box {
  box-shadow: 1px 1px 2px 1px #ccc;
}

@mixin field {
  border: 1px solid #aaa;
  height: 40px;
  padding: 10px;
  margin-top: 20px;
  border-radius: 5px;
  box-sizing: border-box;
}

input[type="text"] {
  @include field;
}

input[type="email"] {
  @include field;
}

input[type="password"] {
  @include field;
}

.invalid {
  border: 2px solid red !important;

  &::placeholder {
    color: red;
  }
}

.errorMessage {
  color: red;
  margin: 10px;
  top: 5px;
}

.w100 {
  width: 100%;
}

#app {
}

.logo {
  width: 300px;
  margin-bottom: 10px;
}

.action {
  height: 40px;
  text-transform: uppercase;
  border-radius: 25px;
  width: 100%;
  border: none;
  cursor: pointer;
  background: green;
  margin-top: 20px;
  color: #fff;
  font-size: 1.2rem;
  @include box;
}

.action-disabled {
  color: #eee;
  background: #aaa;
  cursor: auto;
}

.top {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 10px;
}

.title {
  width: 100%;
  font-size: 1.8rem;
  margin-bottom: 10px;
  text-align: center;
}

.subtitle {
  .subtitle-action {
    color: green;
    font-weight: bold;
    cursor: pointer;
  }
}

.page-style {
  background: linear-gradient(
      to bottom,
      rgba(96, 108, 136, 1) 0%,
      rgba(63, 76, 107, 1) 100%
  ) no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-family: sans-serif;
}

.loginBox {
  background: #fff;
  border-radius: 15px;
  max-width: 400px;
  padding: 25px 55px;
  animation: slideInTop 1s;
}

@keyframes slideInTop {
  from {
    opacity: 0;
    transform: translateY(-30%);
  }

  to {
    opacity: 100;
    transform: translateY(0%);
  }
}

@media screen and (min-width: 440px) {
  .loginBox {
    @include box;
  }
}

@media screen and (max-width: 440px) {
  html {
    background: #fff;
    align-items: start;
    justify-content: start;
  }

  .loginBox {
    padding: 25px 25px;
    max-width: 100vw;
  }
}
</style>